import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["placement", "arrowProps", "show", "popper", "hasDoneInitialMeasure"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import chunk from 'lodash/chunk';
import React from 'react';
import { Card, Col, Overlay, Row, Selectable, Title } from '@mirohq-internal/website-ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OverlayLanguageList = function OverlayLanguageList(_ref) {
  var title = _ref.title,
      target = _ref.target,
      handleClose = _ref.handleClose,
      show = _ref.show,
      selectedValue = _ref.selectedValue,
      items = _ref.items,
      handleSelect = _ref.handleSelect;
  var groupsItems = chunk(items, 7);
  return /*#__PURE__*/_jsx(Overlay, {
    target: target.current,
    show: show,
    placement: "top-start",
    rootClose: true,
    rootCloseEvent: "click",
    onHide: handleClose,
    children: function children(_ref2) {
      var _placement = _ref2.placement,
          _arrowProps = _ref2.arrowProps,
          _show = _ref2.show,
          _popper = _ref2.popper,
          _hasDoneInitialMeasure = _ref2.hasDoneInitialMeasure,
          props = _objectWithoutProperties(_ref2, _excluded);

      return /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({}, props), {}, {
        "data-testid": "overlay-language-list",
        className: classNames('d-none d-md-block ms-n300 border-0'),
        children: /*#__PURE__*/_jsxs(Card.Body, {
          className: "p-400",
          children: [/*#__PURE__*/_jsx(Title, {
            render: "h2",
            className: "d-block category mb-200",
            children: title
          }), /*#__PURE__*/_jsx(Row, {
            className: "d-flex gap-600",
            children: groupsItems.map(function (group) {
              return /*#__PURE__*/_jsx(Col, {
                className: "d-flex flex-column gap-300",
                children: group.map(function (item) {
                  return /*#__PURE__*/_jsx(Selectable, {
                    style: {
                      minWidth: '176px'
                    },
                    selected: selectedValue === item.label,
                    selectedIcon: "CheckMark",
                    href: item.href,
                    eventKey: item.label,
                    onSelect: handleSelect,
                    children: item.label
                  }, item.label);
                })
              }, JSON.stringify(group));
            })
          })]
        })
      }));
    }
  });
};